module.exports = __webpack_public_path__ + "static/media/Flaticon.500d63cc.svg";